import { UPDATE_STAGE_CASE } from "../../constants";

export function approveCase(
    case_task_id,
    case_id,
    this_stage,
    this_user,
    caseDetail,
    stageId,
    stageName,
    user,
    stage
    
) {
    return {
        type: UPDATE_STAGE_CASE.APPROVE_CASE,
        payload: {
            case_task_id,
            case_id,
            this_stage,
            this_user,
            caseDetail,
            stageId,
            stageName,
            user,
            stage
        }
    };
}

export function approvedCase(case_task_id, caseId, this_stage, this_user, stageId, stageName) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_APPROVE_CASE,
        payload: {
            caseId,
            case_task_id,
            this_stage,
            this_user,
            stageId,
            stageName
        }
    };
}

export function failedApproveCase(case_task_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_APPROVE_CASE,
        payload: {
            case_task_id
        },
        error
    };
}

export function proceedCase(
    case_task_id,
    case_id,
    this_stage,
    this_user,
    remarks,
    stageName,
    stageId,
    multiple = false
) {
    return {
        type: !multiple
            ? UPDATE_STAGE_CASE.PROCEED_CASE
            : UPDATE_STAGE_CASE.PROCEED_BULK_CASES,
        payload: {
            case_task_id,
            case_id,
            this_stage,
            this_user,
            remarks,
            stageName,
            stageId,
            multiple
        }
    };
}

export function proceedCaseSucceed(
    case_task_id,
    caseId,
    this_stage,
    this_user,
    remarks
) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_PROCEED_CASE,
        payload: {
            caseId,
            case_task_id,
            this_stage,
            this_user,
            remarks
        }
    };
}

export function proceedCaseFailed(case_task_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_PROCEED_CASE,
        payload: {
            case_task_id
        },
        error
    };
}

export function referCase(
    case_task_id,
    this_stage,
    this_user,
    remarks,
    action_reason,
    stageName,
    stageId,
    wa_category_type_id,
    wa_reason_id = null,
    multiple = false,
    refer_reasons = []
) {
    return {
        type: !multiple
            ? UPDATE_STAGE_CASE.REFER_CASE
            : UPDATE_STAGE_CASE.REFER_BULK_CASES,
        payload: {
            case_task_id,
            this_stage,
            this_user,
            remarks,
            action_reason,
            stageName,
            stageId,
            wa_category_type_id,
            wa_reason_id,
            refer_reasons
        }
    };
}

export function referCaseSucceed(case_task_id, this_stage, this_user, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_REFER_CASE,
        payload: {
            case_task_id,
            this_stage,
            this_user,
            remarks
        }
    };
}

export function referCaseFailed(case_task_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_REFER_CASE,
        payload: {
            case_task_id
        },
        error
    };
}

export function rejectCase(case_id, reason, remarks, stageName, stageId, multiple = false) {
    return {
        type: !multiple
            ? UPDATE_STAGE_CASE.REJECT_CASE
            : UPDATE_STAGE_CASE.REJECT_BULK_CASES,
        payload: {
            case_id,
            reason,
            remarks,
            stageName,
            stageId
        }
    };
}

export function rejectCaseSucceed(case_id, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_REJECT_CASE,
        payload: {
            case_id,
            remarks
        }
    };
}

export function rejectCaseFailed(case_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_REJECT_CASE,
        payload: {
            case_id
        },
        error
    };
}

export function holdCase(case_id, remarks, action_reason, stageName, stageId) {
    return {
        type: UPDATE_STAGE_CASE.HOLD_CASE,
        payload: {
            case_id,
            remarks,
            action_reason,
            stageName,
            stageId
        }
    };
}

export function holdCaseSucceed(case_id, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_HOLD_CASE,
        payload: {
            case_id,
            remarks
        }
    };
}

export function holdCaseFailed(case_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_HOLD_CASE,
        payload: {
            case_id
        },
        error
    };
}

export function openHoldCase(case_id, remarks, stageName, stageId, selectedViewType) {
    return {
        type: UPDATE_STAGE_CASE.OPEN_CASE,
        payload: {
            case_id,
            remarks,
            stageName,
            stageId,
            selectedViewType
        }
    };
}

export function openHoldCaseSucceed(case_id, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_OPEN_CASE,
        payload: {
            case_id,
            remarks
        }
    };
}

export function openHoldCaseFailed(case_id, error) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_OPEN_CASE,
        payload: {
            case_id
        },
        error
    };
}

export function assignCase(case_task_id, this_user, remarks, stageName, stageId, stageType, path, caseId) {
    return {
        type: UPDATE_STAGE_CASE.ASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks,
            stageName,
            stageId,
            stageType,
            path,
            caseId
        }
    };
}
export function assignCaseSucceed(case_task_id, this_user, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_ASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks
        }
    };
}
export function assignCaseFailed(case_task_id, this_user, remarks) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_ASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks
        }
    };
}

export function reassignCase(case_task_id, this_user, remarks, stageName, stageId, stageType, path, caseId) {
    return {
        type: UPDATE_STAGE_CASE.REASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks,
            stageName,
            stageId,
            stageType,
            path,
            caseId
        }
    };
}
export function reassignCaseSucceed(case_task_id, this_user, remarks) {
    return {
        type: UPDATE_STAGE_CASE.SUCCESS_REASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks
        }
    };
}
export function reassignCaseFailed(case_task_id, this_user, remarks) {
    return {
        type: UPDATE_STAGE_CASE.FAILED_REASSIGN_CASE,
        payload: {
            case_task_id,
            this_user,
            remarks
        }
    };
}
